import React from "react";
import "./SetsUsApart.css";

const SetsUsApart = () => {
  const contentList = [
    {
      title: "Multi-Channel Expertise",
      description:
        "We are not just a digital marketing agency or a print advertising company—we are a comprehensive advertising partner. From Videowala Bus stop digital screens to direct messaging and traditional print media, we cover all the bases to ensure your message reaches the right people at the right time.",
      sectionClass: "first-box-section",
    },
    {
      title: "Personalized Approach",
      description:
        "No two businesses are alike, and we understand that. Our solutions are fully customized to meet your unique business needs, whether you are launching a new product, promoting an event, or building long-term brand awareness.",
    },
    {
      title: "Data-Driven Decisions",
      description:
        "We believe in the power of data. Every campaign we execute is backed by detailed performance analytics, ensuring that your advertising strategy is always optimized for success.",
    },
    {
      title: "Wide Coverage",
      description:
        "We take pride in offering one of the widest advertising networks. Our digital screens, print media services give your brand unmatched reach across both urban centers and rural areas.",
      sectionClass: "last-box-section",
    },
  ];

  return (
    <section className="SetsUsApart">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="text-holder">
              <h2 className="heading">What Sets Us Apart?</h2>
            </div>
            <div className="main-container">
              <div className="row me-0 ms-0 main-content-list-holder">
                <div className="col-md-12 p-0">
                  {contentList.map((item, index) => (
                    <div className="row content-row" key={index}>
                      <div className=" col-xl-4 col-md-4 col-lg-5 ">
                        <div className="left-content-holder">
                          <h2>{item.title}</h2>
                        </div>
                      </div>
                      <div className="col-xl-8 col-md-8 col-lg-7">
                        <div className="right-content-holder">
                          <div
                            className={`description ${
                              item.sectionClass || ""
                            }`}
                          >
                            <div className="circle"></div>
                            <p>{item.description}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SetsUsApart;
